import * as React from 'react';

import { SharedState } from 'app/types-shared';
import { hasTranslationsLoaded, translationChanged } from 'app/infrastructure/translate/selectors';
import * as navigate from 'app/area/shared/navigation';

import { getDashboardAdminAccess } from '../../common/get-dashboard-admin-access';
import { DashboardAdminTranslation } from '../../constants';

interface ListWrapperProps {
  displayError: (errorMessage: string) => void;
  sharedState: SharedState;
  translation: DashboardAdminTranslation;
  children?: React.ReactNode;
}

export class ListWrapper
  extends React.PureComponent<ListWrapperProps> {

  public componentDidMount() {
    if (hasTranslationsLoaded(this.props.translation)) {
      this.initList();
    }
  }

  public componentDidUpdate(prevProps: ListWrapperProps) {
    if (translationChanged(this.props.translation, prevProps.translation)) {
      this.initList();
    }
  }

  private initList() {

    const { sharedState, displayError, translation } = this.props;

    if (!getDashboardAdminAccess(sharedState)) {
      displayError(translation.no_access_to_dashboard_admin);
      navigate.toStartupView(true);
    }
  }

  public render() {

    if (!getDashboardAdminAccess(this.props.sharedState)) {
      return null;
    }

    return this.props.children;
  }
}
